import env from 'enviro';

export default function AsyncComponentErrorHandler(chunkName: string) {
  return function handler(error: Error) {
    const errorMessage = `Failed to load chunk ${chunkName}`;
    if (!env.deployed()) {
      console.warn(errorMessage);
      console.error(error);
      return;
    }
  };
}
